import XLSX from 'xlsx';

export const downloadExcelFile = (name: string, sheetname: string, data: string[][]) => {
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetname);
    const timeElapsed = Date.now();
    const today = new Date(timeElapsed);
    XLSX.writeFile(workbook, `${name}_${today.toISOString()}.xlsx`, { compression: true });
};
